/* eslint-disable indent */
import React, { useEffect } from "react";
import styles from "../EditableTag.module.css";
import Seta from "../../../Assets/images/seta.png";
import { useEditableTag } from "./EditableTagBase";
import { ToolbarComponent, CanvasComponent } from "./SharedComponents";

const EditableTag6x4 = ({ initialData, doubleTag = false }) => {
	const canvasSize = { width: 170, height: 103 };
	const {
		canvasRef,
		elements,
		setElements,
		setInitialElements,
		selectedElement,
		setSelectedElement,
		zoom,
		handleMouseDown,
		handleElementClick,
		handleMouseMove,
		handleMouseUp,
		updateElementProperty,
		deleteElement,
		handleZoomIn,
		handleZoomOut,
		handleZoomReset,
		exportToPDF,
		printPDF,
		resetToInitialState
	} = useEditableTag(canvasSize);

	useEffect(() => {
		if (initialData)
			initializeElements(initialData);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [initialData]);

	const initializeElements = (data) => {
		const newElements = [];
		let idCounter = Date.now();

		// Layout 6x4: estrutura row com lado esquerdo (70%) e lado direito
		// Título (cultura) - centralizado no topo
		if (data.culture) {
			newElements.push({
				id: idCounter++,
				type: "text",
				content: data.culture,
				x: 10,
				y: 3,
				width: 150,
				height: 12,
				fontSize: 9,
				fontWeight: "bold",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "center",
				textTransform: "uppercase"
			});
		}

		// Lado esquerdo (70% width)
		const leftSideX = 10;
		const leftSideWidth = 100;

		// Peso Líquido Mínimo - separado em dois elementos inline
		if (data.weight) {
			// Label
			newElements.push({
				id: idCounter++,
				type: "text",
				content: "Peso Líquido Mínimo:",
				x: leftSideX,
				y: 18,
				width: 55,
				height: 8,
				fontSize: 5,
				fontWeight: "bold",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left",
				whiteSpace: "nowrap",
				overflow: "visible"
			});

			// Valor (maior)
			newElements.push({
				id: idCounter++,
				type: "text",
				content: data.weight,
				x: leftSideX + 56,
				y: 16.5,
				width: leftSideWidth - 56,
				height: 10,
				fontSize: 8,
				fontWeight: "bold",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left",
				whiteSpace: "nowrap",
				overflow: "visible"
			});
		}

		// Código de Rastreio
		if (data.trackingCode) {
			newElements.push({
				id: idCounter++,
				type: "text",
				content: `Código de Rastreio: ${data.trackingCode}`,
				x: leftSideX,
				y: 28,
				width: leftSideWidth,
				height: 12,
				fontSize: 5,
				fontWeight: "bold",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left",
				lineHeight: 1.3
			});
		}

		// Produtor
		if (data.producer) {
			const producerInfo = `Distribuído por: ${data.producer.name}\n${data.producer.document}\n${data.producer.address}`;
			newElements.push({
				id: idCounter++,
				type: "text",
				content: producerInfo,
				x: leftSideX,
				y: 41,
				width: leftSideWidth,
				height: 12,
				fontSize: 5,
				fontWeight: "normal",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left",
				lineHeight: 1.0,
				overflow: "visible"
			});
		}

		// Distribuidor
		let currentY = 41 + 12 + 3;
		if (data.distributor) {
			const distributorInfo = `Destino: ${data.distributor.name}\n${data.distributor.document}\n${data.distributor.address}`;
			newElements.push({
				id: idCounter++,
				type: "text",
				content: distributorInfo,
				x: leftSideX,
				y: currentY,
				width: leftSideWidth,
				height: 12,
				fontSize: 5,
				fontWeight: "normal",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left",
				lineHeight: 1.0,
				overflow: "visible"
			});
			currentY += 14;
		}

		// Datas
		if (data.dates) {
			let dateText = "";
			if (data.dates.packaging) dateText += `Data de Embalagem: ${data.dates.packaging}\n`;
			if (data.dates.delivery) dateText += `Data de Entrega: ${data.dates.delivery}\n`;
			if (data.dates.expiry) dateText += `Data de Validade: ${data.dates.expiry}`;

			// Calcular altura necessária para caber antes do footer (Y=91)
			const maxHeight = 91 - currentY - 1;

			newElements.push({
				id: idCounter++,
				type: "text",
				content: dateText,
				x: leftSideX,
				y: currentY,
				width: leftSideWidth,
				height: maxHeight,
				fontSize: 4.5,
				fontWeight: "normal",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left",
				lineHeight: 1.0,
				overflow: "visible"
			});
		}

		// Lado direito - QR Code e código de barras
		const rightSideX = 115;

		// Textos acima do QR Code
		newElements.push({
			id: idCounter++,
			type: "text",
			content: "CONHEÇA ORIGEM",
			x: rightSideX,
			y: 18,
			width: 50,
			height: 6,
			fontSize: 5,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center",
			lineHeight: 1.2
		});

		newElements.push({
			id: idCounter++,
			type: "text",
			content: "DESTE PRODUTO",
			x: rightSideX,
			y: 24,
			width: 50,
			height: 6,
			fontSize: 5,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center",
			lineHeight: 1.2
		});

		// QR Code
		if (data.qrCode) {
			newElements.push({
				id: idCounter++,
				type: "image",
				content: data.qrCode,
				x: rightSideX,
				y: 30,
				width: 50,
				height: 50
			});
		}

		// Código de Barras
		if (data.barCode) {
			newElements.push({
				id: idCounter++,
				type: "image",
				content: data.barCode,
				x: rightSideX,
				y: 75,
				width: 50,
				height: 16,
				objectFit: "fill"
			});
		}

		// Footer
		const footerY = 91;
		const footerHeight = 10;

		// Fundo preto do footer
		newElements.push({
			id: idCounter++,
			type: "footer-background",
			content: "",
			x: 0,
			y: footerY,
			width: canvasSize.width,
			height: footerHeight,
			backgroundColor: "black",
			isFooterElement: true,
			zIndex: -1
		});

		// Layout do footer: seta | texto | seta | texto | seta
		const footerElements = [
			{ type: "image", content: Seta, width: 8 },
			{ type: "text", content: "ORIGEM RASTREADA", flex: 1 },
			{ type: "image", content: Seta, width: 8, transform: "scaleX(-1)" },
			{ type: "text", content: "sisagri.com.br", flex: 1 },
			{ type: "image", content: Seta, width: 8, transform: "scaleX(-1)" }
		];

		// Calcular distribuição do footer
		const totalFlex = footerElements.filter(el => el.flex).reduce((sum, el) => sum + el.flex, 0);
		const fixedWidth = footerElements.filter(el => !el.flex).reduce((sum, el) => sum + el.width, 0);
		const availableWidth = canvasSize.width - 4; // padding
		const flexWidth = (availableWidth - fixedWidth) / totalFlex;

		let currentX = 2;
		footerElements.forEach((el) => {
			const width = el.flex ? flexWidth : el.width;

			if (el.type === "image") {
				newElements.push({
					id: idCounter++,
					type: "image",
					content: el.content,
					x: currentX,
					y: footerY + 1,
					width: width,
					height: 8,
					transform: el.transform || "none",
					isFooterElement: true
				});
			} else {
				newElements.push({
					id: idCounter++,
					type: "text",
					content: el.content,
					x: currentX,
					y: footerY + 1,
					width: width,
					height: 8,
					fontSize: 6,
					fontWeight: "bold",
					fontFamily: "Roboto, Arial, sans-serif",
					textAlign: "center",
					color: "white",
					lineHeight: 1.0,
					isFooterElement: true
				});
			}

			currentX += width;
		});

		setElements(newElements);
		setInitialElements(JSON.parse(JSON.stringify(newElements)));
	};

	const selectedElementData = elements.find(el => el.id === selectedElement);

	return (
		<div className={styles.editorContainer}>
			<ToolbarComponent
				selectedElementData={selectedElementData}
				updateElementProperty={updateElementProperty}
				handleZoomOut={handleZoomOut}
				handleZoomIn={handleZoomIn}
				handleZoomReset={handleZoomReset}
				zoom={zoom}
				exportToPDF={() => exportToPDF("6x4", doubleTag)}
				printPDF={() => printPDF(doubleTag)}
				resetToInitialState={resetToInitialState}
			/>

			<CanvasComponent
				canvasRef={canvasRef}
				canvasSize={canvasSize}
				zoom={zoom}
				elements={elements}
				selectedElement={selectedElement}
				setSelectedElement={setSelectedElement}
				handleMouseMove={handleMouseMove}
				handleMouseUp={handleMouseUp}
				handleMouseDown={handleMouseDown}
				handleElementClick={handleElementClick}
				deleteElement={deleteElement}
			/>
		</div>
	);
};

export default EditableTag6x4;
